import { createApi } from '@reduxjs/toolkit/query/react';
import { GenericResponse } from '@/redux/models';
import customFetchBase from './customFetchBase';




export const archivoApi = createApi({
  reducerPath: 'archivoApi',
  baseQuery: customFetchBase,
  tagTypes: ['archivo'],
  endpoints: (builder) => ({
    subirFacturaACarpeta: builder.mutation<GenericResponse, { carpeta: number, factura: FormData, fecha: string }>({
      query: ({ carpeta, factura, fecha }) => ({
        url: `archivo/factura?carpeta=${carpeta}&fecha=${fecha}`,
        method: 'POST',
        credentials: 'include',
        body: factura

      }),
    }),
    borrarFactura: builder.mutation<GenericResponse, { carpeta: number }>({
      query: ({ carpeta }) => ({
        url: `archivo/factura/?carpeta=${carpeta}`,
        method: 'DELETE',
        credentials: 'include',
      }),
    }),
    buscarArchivoPorNombre: builder.query<GenericResponse, { nombre: string }>({
      query: ({ nombre }) => ({
        url: `archivo/buscar?nombreArchivo=${nombre}`,
        method: 'GET',
        credentials: 'include',

      }),
    })
  }),
});

export const {
  useSubirFacturaACarpetaMutation,
  useBorrarFacturaMutation,
  useBuscarArchivoPorNombreQuery

} = archivoApi;
